<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeForm"
    :title="rowInfo.id===''?'添加项目':'编辑项目'"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="rowInfo.projectName" placeholder="项目名称" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地" prop="cityCode">
              <el-select v-model="rowInfo.cityCode" clearable  multiple filterable placeholder="请选择所在地" style="width:220px">
                <el-option
                    v-for="item in cityOptions"
                    :key="item.codeItemId"
                    :label="item.codeName"
                    :value="item.codeItemId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目负责人">
              <el-input v-model="rowInfo.projectHead" placeholder="项目负责人" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="projectPhone">
              <el-input v-model="rowInfo.projectPhone" placeholder="联系电话" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="12">
            <el-form-item label="联系邮箱" prop="projectEmail">
              <el-input v-model="rowInfo.projectEmail" placeholder="联系邮箱" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                :autosize="{ minRows: 3, maxRows: 5}"
                v-model="rowInfo.remark"
                placeholder="备注"
                type="textarea"
                resize = "none"
                style="width:90%;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addListpage,getDynamicFormValue} from  "@/api/project/index"
import { mapGetters } from 'vuex';
import {citys} from "@/const/city";
export default {
  components: {
  },
  computed: {
    headers() {
      return {
        Authorization: `Bearer ${this.accessToken}`,
      };
    },
    ...mapGetters(['accessToken'])
  },
  data() {
    // 手机号
    let validatePhone = (rule, value, callback) => {
      let isNum = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的电话'))
      }
      callback()
    }
    let validateEmail = (rule, value, callback) => {
      let isNum = /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的邮箱'))
      }
      callback()
    }
    return {
      visible: false,
      formName: '新增',
      loading: false,
      selectDate:'',
      cityOptions:citys,
      rowInfo: {
        id: '',
        projectName: '',
        cityCode: '',
        cityName: [],
        projectHead: '',
        projectPhone: '',
        projectEmail: '',
        status: 1,
        remark: '',
      },
      rules: {
        projectName: [{ required: true, message: '必填:项目名称', trigger: 'blur' }],
        cityCode: [{ required: true, message: '必填:所在地', trigger: 'change' }],
        projectPhone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        projectEmail: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    init(id) {
      this.visible = true
      this.rowInfo.id = id
      if (id) {
        getDynamicFormValue(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data
            }
        })
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.rowInfo.cityName = []
          this.rowInfo.cityCode.find(code => {
            let obj = {}
            obj = this.cityOptions.find(item => {
              return item.codeItemId === code //筛选出匹配数据
            })
            this.rowInfo.cityName.push(obj.codeName);
          })
          addListpage({
            id: this.rowInfo.id,
            projectName: this.rowInfo.projectName,
            cityCode: this.rowInfo.cityCode.join(),
            cityName: this.rowInfo.cityName.join(),
            projectHead: this.rowInfo.projectHead,
            projectPhone: this.rowInfo.projectPhone,
            projectEmail: this.rowInfo.projectEmail,
            status: this.rowInfo.status,
            remark: this.rowInfo.remark,
          }).then((res) => {
            if (res.data.code==0) {
              // 在store中改变修改的值
              if (this.rowInfo.id) {
                this.$message.success("编辑成功")
              } else {
                this.$message.success("添加成功")
              }
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
              this.closeForm()
            }
          })
        } else {
          return false
        }
      })
    },

    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields();
      this.selectDate = '';
      this.rowInfo = {
        id: '',
        projectName: '',
        cityCode: [],
        cityName: [],
        projectHead: '',
        projectPhone: '',
        projectEmail: '',
        status: 1,
        remark: ''
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
